import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["value", "defaultValue", "label", "hintMessage", "error", "formatter", "renderCalendar", "onChange", "onClear", "onConfirm", "onBlur", "bgColor"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/DatePicker/DatePicker.js",
    _this = this,
    _templateObject,
    _templateObject2;

import React, { useEffect, useState } from 'react';
import styled, { css, createGlobalStyle } from 'styled-components';
import CalendarIcon from '@dls/assets/icons/Calendar';
import FormField, { FormFieldContext } from '../../core/components/Forms/FormField';
import LabelText from '../../core/components/Forms/LabelText';
import FormFieldHint from '../../core/components/Forms/FormFieldHint';
import HintText from '../../core/components/Forms/HintText';
import { FieldWrapper, IconWrapper, LabelWrapper, SelectedText } from '../DropdownInput';
import FormInput from '../../core/components/Forms/FormInput';
import { withTheme } from '../../core/ThemeProvider';
import { SingleDatePickerCalendar } from './calendarViews';
import supportedFormats from './supportedFormats';
import { formatDate } from '../../core/utils';
import Config from '../../config';
/**
 * Date picker form field component.
 * Renders a form field with a date value.
 *
 * ```js
 * <DatePicker
 *   label={"Pick a delivery date"}
 *   hintMessage={"Note that weekends and public holidays are not available."}
 * ```
 */

var DatePicker = withTheme(function (_ref) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      label = _ref.label,
      hintMessage = _ref.hintMessage,
      error = _ref.error,
      formatter = _ref.formatter,
      renderCalendar = _ref.renderCalendar,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      onConfirm = _ref.onConfirm,
      _onBlur = _ref.onBlur,
      bgColor = _ref.bgColor,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownVisible = _useState2[0],
      setDropDownVisible = _useState2[1];

  var _useState3 = useState(value || defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedDate = _useState4[0],
      setSelectedDate = _useState4[1];

  useEffect(function () {
    value !== undefined && setSelectedDate(value);
  }, [value]);

  var onDropdownClick = function onDropdownClick() {
    setDropDownVisible(!dropdownVisible);
  };

  var useSelectedDate = function useSelectedDate() {
    return {
      selectedDate: selectedDate,
      setSelectedDate: setSelectedDate
    };
  };

  var useDropdownVisible = function useDropdownVisible() {
    return {
      dropdownVisible: dropdownVisible,
      setDropDownVisible: setDropDownVisible
    };
  };

  var renderDropdownCalendar = function renderDropdownCalendar(visible) {
    return visible ? /*#__PURE__*/React.createElement(DropdownContainer, {
      onClick: function onClick(e) {
        return e.preventDefault();
      },
      "data-testid": "dropdown-container",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 9
      }
    }, renderCalendar ? renderCalendar({
      useSelectedDate: useSelectedDate,
      useDropdownVisible: useDropdownVisible
    }) : /*#__PURE__*/React.createElement(SingleDatePickerCalendar, {
      datePickerProps: {
        onChange: onChange,
        onClear: onClear,
        onConfirm: onConfirm
      },
      formatter: formatter,
      useDropdownVisible: useDropdownVisible,
      useSelectedDate: useSelectedDate,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 76,
        columnNumber: 13
      }
    })) : null;
  };
  /* TODO: Refactor.Dropdown and Datepicker use the same dropdown logic. */


  return /*#__PURE__*/React.createElement(React.Fragment, null, dropdownVisible && /*#__PURE__*/React.createElement(NoBackgroundActivity, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 29
    }
  }), /*#__PURE__*/React.createElement("div", {
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 94,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormField, {
    defaultValue: serializeDateValue(selectedDate),
    error: error,
    bgColor: bgColor,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 95,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormFieldContext.Consumer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 13
    }
  }, function (_ref2) {
    var hasFocus = _ref2.hasFocus;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 104,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(LabelWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105,
        columnNumber: 23
      }
    }, /*#__PURE__*/React.createElement(SelectedText, {
      hasValue: !!selectedDate,
      "data-testid": "datepicker-selectedText",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 106,
        columnNumber: 25
      }
    }, selectedDate && formatDate(selectedDate, formatter))), /*#__PURE__*/React.createElement(IconWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 113,
        columnNumber: 23
      }
    }, /*#__PURE__*/React.createElement(CalendarIcon, {
      size: 24,
      color: rest.coreTheme.cl_sec_d1,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 114,
        columnNumber: 25
      }
    })), /*#__PURE__*/React.createElement(LabelText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 119,
        columnNumber: 23
      }
    }, label), /*#__PURE__*/React.createElement(HiddenInput, {
      value: serializeDateValue(selectedDate),
      onBlur: function onBlur() {
        _onBlur && _onBlur();
        setDropDownVisible(false);
      },
      onClick: onDropdownClick,
      "data-testid": "datepicker-input",
      readOnly: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 120,
        columnNumber: 23
      }
    })), renderDropdownCalendar(dropdownVisible && hasFocus));
  })), hintMessage && /*#__PURE__*/React.createElement(FormFieldHint, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(HintText, {
    error: error,
    "data-testid": "errorId",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 15
    }
  }, hintMessage))));
});
DatePicker.defaultProps = {
  formatter: supportedFormats['dd MMM yyyy'],
  bgColor: 'white'
};
DatePicker.dateFormats = supportedFormats;
export default DatePicker;
var HiddenInput = styled(FormInput).withConfig({
  displayName: "DatePicker__HiddenInput",
  componentId: "sc-1xkecub-0"
})(["position:absolute;left:-999999px;height:0;width:0;opacity:0;"]);
var DropdownContainer = withTheme(styled.div.withConfig({
  displayName: "DatePicker__DropdownContainer",
  componentId: "sc-1xkecub-1"
})(function (_ref3) {
  var coreTheme = _ref3.coreTheme;
  return css(["position:fixed;z-index:1;top:0;left:0;height:100vh;width:100vw;margin:0;text-align:center;background:", ";", ""], coreTheme.cl_white, Config.media.sm(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        position: absolute;\n        top: 100%;\n        left: -1px;\n        height: unset;\n        width: unset;\n        margin-top: ", "px;\n      "])), coreTheme.space_2));
})); // Disable background scroll when fullscreen popup is open (mobile view)

var NoBackgroundActivity = withTheme(createGlobalStyle(["body{height:100vh;overflow:hidden;}", ""], Config.media.sm(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    body {\n      height: unset;\n      overflow: visible;\n    }\n  "])))));

var serializeDateValue = function serializeDateValue(selectedDate) {
  if (!selectedDate) return;

  if (selectedDate instanceof Date) {
    return selectedDate.toISOString();
  } else if (selectedDate.from instanceof Date || selectedDate.to instanceof Date) {
    return "".concat(selectedDate.from.toISOString(), " - ").concat(selectedDate.to.toISOString());
  }
};